export default function SignalBars({ level = 0 }) {
  const totalBars = 5;
  const bars = Array.from({ length: totalBars }, (_, i) => i + 1);

  return (
    <div className="signal-bars">
      {bars.map((bar) => (
        <div
          key={bar}
          className={`signal-bar ${bar <= level ? "active" : ""}`}
          style={{ height: `${3 + bar * 2}px` }}
        />
      ))}
    </div>
  );
}
